import {
  CLEAR_ALL,
  GET_ALL,
  GET_ALL_ERROR,
  AGENT_LIST_LOADING,
} from "../constants/action-types";
import {
  getSubAgencies,
  getSubAgenciesByDirectorID
} from "../../services/GraphQl/BDSWebService";
import _ from "lodash";
import stringUtils from "../../utils/stringUtils";

/* redux-thunk implementation */
export const clearStore = () => {
  return (dispatch) => {
    dispatch({ type: CLEAR_ALL, payload: {} });
  };
};

export const getAgencyByDirectorID = (directorId) => {
  return async (dispatch) => {
    dispatch({
      type: AGENT_LIST_LOADING,
      payload: true,
    });

    try {
      // get agent list agencies by director ID
      var agentListAgencies = await getSubAgenciesByDirectorID(directorId);
      if (agentListAgencies) {
        agentListAgencies = agentListAgencies.filter(
          (row) => row.agentId !== sessionStorage.getItem("agentId")
        );
        /* alpha sort */
        agentListAgencies = _.sortBy(agentListAgencies, "subagencyName");
        /* upper first chars */
        agentListAgencies = agentListAgencies.map((row) => ({
          ...row,
          name: stringUtils.firstUpperLetter(row.subagencyName),
        }));
        agentListAgencies = [...new Set(agentListAgencies)];
        // dispatch all required parts
        dispatch(getAgencyAction({ agentListAgencies }));
      }
    } catch (error) {
      dispatch({
        type: GET_ALL_ERROR,
        payload: { error },
      });
    } finally {
      dispatch({
        type: AGENT_LIST_LOADING,
        payload: false,
      });
    }
  };
};

export const getAgency = (agencyId) => {
  return async (dispatch) => {
    dispatch({
      type: AGENT_LIST_LOADING,
      payload: true,
    });

    // getAgencyEmailOwner(parseInt(agencyId)).then((data) => {
    //   if (data?.data.getAgencyEmailOwner) {
    //     sessionStorage.setItem(
    //       "adminEmail",
    //       data.data.getAgencyEmailOwner.adminEmail
    //     );
    //   }
    // });

    try {
      // get agent list agencies
      var agentListAgencies = await getSubAgencies(parseInt(agencyId));
      if (agentListAgencies) {
        agentListAgencies = agentListAgencies.filter(
          (row) => row.agentId !== sessionStorage.getItem("agentId")
        );
        /* alpha sort */
        agentListAgencies = _.sortBy(agentListAgencies, "subagencyName");
        /* upper first chars */

        agentListAgencies = agentListAgencies.map((row) => {
          // Return a new object with the updated name
          return {
            ...row,
            name: stringUtils.firstUpperLetter(row.subagencyName),
          };
        });
        agentListAgencies = [...new Set(agentListAgencies)];
        // dispatch all required parts
        dispatch(
          getAgencyAction({
            agentListAgencies: agentListAgencies,
          })
        );
      }
    } catch (error) {
      dispatch({
        type: GET_ALL_ERROR,
        payload: { error },
      });
    } finally {
      dispatch({
        type: AGENT_LIST_LOADING,
        payload: false,
      });
    }
  };
};

/* redux action */

const getAgencyAction = (data) => {
  return {
    type: GET_ALL,
    payload: data,
  };
};
